import { parseItems } from "../slices/utils";

export const dataDetalhesPedidoReducer = (state, action) => {
  state.items = parseItems(action.payload.items);
  state.requestGetParams = { ...action.meta.arg };
};
